import produce from "immer";
import { useSession } from "next-auth/react";
import Link from "next/link";
import useSWR from "swr";
import { fetcher } from "../../../../../common/helper";
import { Plate as PlateType } from "../../../../../pages/api/plata/get";
import InfoText from "../InfoText/InfoText";
import Neulogovan from "../Utisci/components/Neulogovan/Neulogovan";
import BezPlate from "./components/BezPlate";
import Plata from "./components/Plata";

interface PlateProps {
    companyId: number;
    slug: string;
    name: string;
    plate?: PlateType[];
}

export default function Plate({ companyId, slug, plate, name }: PlateProps) {
    const dvePlate = produce(plate, (draft) => draft?.slice(0, 2));

    const { data: session, status } = useSession();

    const { data: userPlata } = useSWR(
        session ? `/api/plata/user?id=${companyId}` : null,
        fetcher
    );

    // @napomena: Prethodno smo ovdje gledali da korisnik ima i ostavljen utisak da bi vidio sve, za sada vracamo da mora biti samo ulogovan.
    const korisnikUlogovan = status === "authenticated"; //  && userPlata?.hasAny;

    const plateZaPrikazati = korisnikUlogovan ? plate : dvePlate;

    return (
        <section className="relative">
            <InfoText />
            {plateZaPrikazati?.length > 2 && (
                <div className="text-center mb-14">
                    <Link
                        href={`/unesi-platu?kompanija=${companyId}&slug=${slug}`}
                    >
                        <button
                            className="btn-primary rounded-md disabled:bg-gray-300"
                            type="button"
                            disabled={userPlata?.exist}
                        >
                            {userPlata?.exist
                                ? "Već ste ostavili platu"
                                : "Unesi anonimno svoju platu"}
                        </button>
                    </Link>
                </div>
            )}
            <h2 className="text-center font-thin my-8">{name} plate</h2>
            <div className="lg:px-0 w-full m-auto mb-8 ">
                {plateZaPrikazati?.map((plata) => (
                    <Plata plata={plata} />
                ))}
                {plateZaPrikazati?.length < 1 && (
                    <BezPlate id={companyId} slug={slug} />
                )}
                {!korisnikUlogovan && plate?.length > 2 && <Neulogovan />}
            </div>
            <div className="text-center">
                <Link href={`/unesi-platu?kompanija=${companyId}&slug=${slug}`}>
                    <button
                        className="btn-primary rounded-md disabled:bg-gray-300"
                        type="button"
                        disabled={userPlata?.exist}
                    >
                        {userPlata?.exist
                            ? "Već ste ostavili platu"
                            : "Unesi anonimno svoju platu"}
                    </button>
                </Link>
            </div>
        </section>
    );
}
